import React from 'react';
import '../styles/SessionSummary.css';

const SessionSummary = ({ itemCount, totalQty, totalAmount }) => {
  return (
    <div className="card stats-card">
      <h3 className="card-title">
        <div className="summary-icon">
          <span className="icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
              <path d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" />
            </svg>
          </span>
        </div>
        Session Summary
      </h3>
      <div className="stats-grid">
        <div className="stat-item">
          <span className="stat-value">{itemCount}</span>
          <span className="stat-label">Items</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{totalQty}</span>
          <span className="stat-label">Qty</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{totalAmount}</span>
          <span className="stat-label">LKR</span>
        </div>
      </div>
    </div>
  );
};

export default SessionSummary;